import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
// import Typography from "@material-ui/core/Typography";
// import Switch from "@material-ui/core/Switch";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Botonera from "../Botonera";
import SwitchFiltros from "./SwitchFiltros";
import ListadoContext from "../context/ListadoContext";
import "./filtros.scss";
import {
  coincideConFiltrosSincronizados,
  crearFirmaFiltros,
} from "../../helper/sincronizacionFiltros";

// ver como reemplazar este makeStyles

const Filtros = (props) => {
  const {
    filtros,
    requestData: aplicarFiltros,
    filtroActivo,
    //loading_pantalla:loading,
    loading,
    opcionesListado,
    listadoBotones,
    handleCancelar,
    dispatch,
    id_global, opElegida, setOpElegida,
  } = useContext(ListadoContext);

  const { opciones, setMapa, data, tieneMapaCab, actuarOnChange, ocultarToggleMapa } =
    props;

  // const { insertar } = useContext(FuncionesContext);

  const [filtrosAAplicar, setFiltrosAAplicar] = useState(filtroActivo);

  const [expanded, setExpanded] = useState(false);
  const [requeridos, setRequeridos] = useState([]);
  const [error, setError] = useState({});
  const timerRef = useRef(null);
  const firstRender = useRef(true);
  const firmaFiltrosSincronizados = useRef(
    crearFirmaFiltros(filtroActivo)
  );
  //const [opElegida, setOpElegida] = useState({});

  const sincronizarFiltrosDesdeBack = useCallback((actualizador) => {
    setFiltrosAAplicar((filtrosActuales) => {
      const filtrosActualizados =
        typeof actualizador === "function"
          ? actualizador(filtrosActuales)
          : actualizador;
      const firmaActualizada = crearFirmaFiltros(filtrosActualizados);

      firmaFiltrosSincronizados.current = firmaActualizada;

      if (firmaActualizada === crearFirmaFiltros(filtrosActuales)) {
        return filtrosActuales;
      }
      return filtrosActualizados;
    });
  }, []);

  opciones.filtros = filtrosAAplicar;
  opciones.dispatch = dispatch;
  opciones.id_global = id_global;

  const cancelar = opciones.listado_boton_cancelar === "s" ? true : false;

  useEffect(() => {
    filtros
      .filter((f) => f.componente !== "hidden")
      .forEach((f) => {
        if (f.permite_null === "n") {
          setRequeridos((s) => {
            const ns = s.concat(f.id_a);
            return ns;
          });
        }

        setError((s) => {
          return { ...s, [f.id_a]: false };
        });
      });
  }, []);

  useEffect(() => {
    const firmaFiltroActivo = crearFirmaFiltros(filtroActivo);
    firmaFiltrosSincronizados.current = firmaFiltroActivo;
    setFiltrosAAplicar((filtrosActuales) =>
      crearFirmaFiltros(filtrosActuales) === firmaFiltroActivo
        ? filtrosActuales
        : filtroActivo
    );

    // console.log("filtros activos en filtros", filtroActivo, Date.now()); // ACA HAY UN ERROR DE LOGICA REACT Radio Button Loco viene por aca?
  }, [filtroActivo]);

  const validar = useCallback(() => {
    let filtrosValidados = [];

    let opcionales = filtros
      .filter((f) => f.opcionales_null === "s")
      .map((f) => f.id_a);

    if (requeridos.length > 0) {
      requeridos.forEach((r) => {
        const filtroAValidar = filtros.filter((f) => f.id_a === r).pop();

        if (!filtrosAAplicar[r] || filtrosAAplicar[r] === null) {
          filtrosValidados[r] = true;
          return;
        }
        if (
          typeof filtrosAAplicar[r] === "string" &&
          filtrosAAplicar[r].trim() === ""
        ) {
          filtrosValidados[r] = true;
          return;
        }
        if (
          filtroAValidar.componente === "fecha" &&
          JSON.parse(filtrosAAplicar[r]).filter((f) => f).length !== 2
        ) {
          filtrosValidados[r] = true;
          return;
        }
        filtrosValidados[r] = false;
      });
    }

    const filtrosConValoresValidos = Object.keys(filtrosValidados).filter(
      (fv) => filtrosValidados[fv] === false
    );
    if (filtrosConValoresValidos.some((fcvv) => opcionales.includes(fcvv))) {
      Object.keys(filtrosValidados).forEach((k) => {
        if (opcionales.includes(k)) return (filtrosValidados[k] = false);
        return;
      });
    }
    // console.log(filtrosValidados)
    setError(() => filtrosValidados);
    return (
      Object.keys(filtrosValidados).filter((f) => filtrosValidados[f])
        .length === 0
    );
  }, [filtros, filtrosAAplicar, requeridos]);

  const handleSubmit = useCallback(
    async (quienLlama) => {
      if (loading) return;

      if (validar()) {
        aplicarFiltros({
          filtrosAAplicar,
          quienLlama,
          qsBodyAdicional: opElegida, // envia las opciones elegidas en los selects como objeto.
        });

        return;
      }
    },
    [aplicarFiltros, filtrosAAplicar, loading, validar]
  );

  const setFiltros = (filtros) => {
    setFiltrosAAplicar(filtros);
  };

  const hayObligatorios =
    filtros.filter((f) => f.permite_null === "n").length > 0;
  const filtrosVisibles = filtros.filter(
    (f) => f.componente !== "hidden"
  ).length;

  const botonesSuperiores = listadoBotones.filter(
    (b) => b.listado_boton_inferior !== "s"
  );
  // console.log(botonesSuperiores, "botones superiores")

  const handleSubmitRef = useRef(handleSubmit);

  useEffect(() => {
    handleSubmitRef.current = handleSubmit;
  }, [handleSubmit]);

  useEffect(() => {
    if (!actuarOnChange) return;
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (
      coincideConFiltrosSincronizados({
        filtros: filtrosAAplicar,
        firmaSincronizada: firmaFiltrosSincronizados.current,
      })
    ) {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = null;
      return;
    }

    // limpiar timer anterior si existe
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // programar nueva ejecución
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      handleSubmitRef.current("filtroRequest");
    }, 500);

    // cleanup al desmontar o antes de volver a entrar
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [actuarOnChange, filtrosAAplicar]);

  return (
    <div className={`${filtrosVisibles === 0 ? "m-0" : ""}`}>
      {/* <button onClick={() => console.log(filtrosAAplicar)}>Ver Filtros A Aplicar</button> */}
      {filtrosVisibles > 0 ? (
        <Paper
          elevation={4}
          style={{ margin: "0.3rem", boxShadow: "none" }}
          className={`${expanded ? "paperAbierto" : ""
            } container_filtros borde-tarjeta mb-2`}
        >
          <div className="filtro_grid" style={{ paddingBottom: "0.3rem" }}>
            <div className="filtro_grid_inputs_grid">
              {filtros
                .filter((f) => f.filtro_avanzado !== "s")
                ?.sort((a, b) => a.orden - b.orden)
                .map((f) => {
                  return (
                    <SwitchFiltros
                      {...f}
                      key={f.id_a}
                      filtrosAAplicar={filtrosAAplicar}
                      setFiltrosAAplicar={setFiltros}
                      sincronizarFiltrosDesdeBack={sincronizarFiltrosDesdeBack}
                      requeridos={requeridos}
                      setRequeridos={setRequeridos}
                      error={error}
                      setError={setError}
                      context={ListadoContext}
                      handleSubmit={handleSubmit}
                      id={f.id_a}
                      actuarOnChange={actuarOnChange}
                      setOpElegida={setOpElegida}
                    />
                  );
                })}
            </div>
          </div>
          {/* expanded true */}
          {filtros.filter((f) => f.filtro_avanzado === "s").length > 0 ? (
            <Accordion
              defaultExpanded={false}
              expanded={expanded}
              onChange={() => setExpanded((s) => !s)}
              style={{ boxShadow: "none" }}
              className={`acordion ${expanded ? "bloque-accordion-abierto" : "bloque-accordion"
                }`}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id="panel1bh-header"
              >
                {expanded ? (
                  <></>
                ) : (
                  <Typography variant="caption" className={"typo"}>
                    Más opciones de busqueda...
                  </Typography>
                )}
              </AccordionSummary>
              <div className="filtro_grid" style={{ marginTop: 0 }}>
                <div className="filtro_grid_inputs_grid">
                  {filtros
                    .filter((f) => f.filtro_avanzado === "s")
                    ?.sort((a, b) => a.orden - b.orden)
                    .map((f) => {
                      return (
                        <SwitchFiltros
                          {...f}
                          key={f.id_a}
                          filtrosAAplicar={filtrosAAplicar}
                          setFiltrosAAplicar={setFiltrosAAplicar}
                          sincronizarFiltrosDesdeBack={sincronizarFiltrosDesdeBack}
                          requeridos={requeridos}
                          setRequeridos={setRequeridos}
                          error={error}
                          setError={setError}
                          context={ListadoContext}
                          actuarOnChange={actuarOnChange}
                        />
                      );
                    })}
                </div>
              </div>
            </Accordion>
          ) : (
            <></>
          )}
          {hayObligatorios ? (
            <div
              id="campos_obligatorios"
              style={{
                padding: "0 1.5rem ",
                display: "flex",
                fontSize: "0.6rem",
                fontStyle: "italic",
                filter: "opacity(0.8)",
              }}
            >
              <span style={{ color: "red" }}>*</span>{" "}
              <div style={{ marginRight: "0.8rem" }}>Campo requerido</div>
              <span style={{ color: "red" }}>**</span> Campo requerido opcional
            </div>
          ) : (
            <></>
          )}
        </Paper>
      ) : (
        <></>
      )}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Botonera
          handleSubmit={handleSubmit}
          handleCancelar={handleCancelar}
          loading={loading}
          buscar={filtrosVisibles > 0}
          cancelar={cancelar && filtrosVisibles > 0}
          acciones={botonesSuperiores}
          context={ListadoContext}
          submit={opcionesListado.submit_button}
          submit_texto={opcionesListado.submit_texto}
          submit_handleSubmit={opcionesListado.submit_button_handleSubmit}
          data={data[0]}
          hayDatos={true}
          actuarOnChange={actuarOnChange}
        />
        {!ocultarToggleMapa && opcionesListado.usar_mapa === "s" ? (
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {tieneMapaCab ? (
                <></>
              ) : (
                <div style={{ fontSize: "0.5rem" }}>
                  No hay configuracion Mapa para mostrar
                </div>
              )}
              <Switch
                onChange={() => setMapa((s) => !s)}
                color="primary"
                className="list-toggle"
              />
              <div
                style={{
                  fontSize: "0.6rem",
                  textAlign: "center",
                  marginTop: "-0.5rem",
                }}
              >
                Mapa
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Filtros;
